// src/components/Tables/TableComponent.js
import React from "react";

const Table = ({ header, children }) => {
  return (
    <div className="py-6">
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-x-auto">
        <table className="min-w-full">
          <thead className="bg-gradient-to-r from-blue_primary to-gray-800">
            <tr>
              {header?.map((name, index) => (
                <th
                  key={index}
                  className="py-3 px-4 text-left text-xs font-semibold text-white uppercase tracking-wider border-r border-gray-600 last:border-r-0 whitespace-nowrap"
                >
                  {name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">{children}</tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
